var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnersHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2991 15.0013C12.7855 15.0013 12.3691 14.5849 12.3691 14.0713V11.5582V8.54152C12.3691 8.26915 12.258 8.00857 12.0615 7.81998L9.69232 5.54657C9.3054 5.17528 8.69448 5.17528 8.30756 5.54657L5.93842 7.81998C5.7419 8.00857 5.6308 8.26915 5.6308 8.54152V14.0713C5.6308 14.5849 5.21441 15.0013 4.70078 15.0013C4.18714 15.0013 3.77075 14.5849 3.77075 14.0713V9.62341C3.77075 9.27911 3.49164 9 3.14734 9C2.57624 9 2.30575 8.29592 2.72995 7.91354L8.3304 2.86525C8.71088 2.52228 9.289 2.52228 9.66948 2.86525L15.2699 7.91354C15.6941 8.29592 15.4236 9 14.8525 9C14.5082 9 14.2291 9.27911 14.2291 9.62341V14.0713C14.2291 14.5849 13.8127 15.0013 13.2991 15.0013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnersHub);
export default __webpack_public_path__ + "static/media/LearnersHub.b5d306c20df28f6170bb85dce2367a7e.svg";
export { ForwardRef as ReactComponent };